<div class="container-sm">
    <h1 class="m-3 display-6 vm-container-header"><i class="bi bi-shield-check me-2"></i> EDI Sender/Receivers</h1>

    <div class="pb-5">
        <div class="m-3 p-2 bg-body-light rounded-3 shadow">
            <div class="m-2 pb-1">
                <form autocomplete="off">
                    <div class="mb-3 row align-items-center">
                        <div class="input-group col-sm-auto">
                            <span class="input-group-text" id="search-addon"><i class="bi bi-search"></i></span>
                            <input [(ngModel)]="this.service.searchTerm" class="form-control shadow-none"
                                   id="table-complete-search" name="searchTerm" type="text"
                                   placeholder="Search" aria-label="Search" aria-describedby="search-addon"/>
                        </div>
                        <div class="col-auto ms-auto">
                            <button type="button" class="btn btn-outline-info"
                                    title="Help" aria-label="Help"
                                    (click)="openHelp()">
                                <i class="bi bi-question-circle me-2"></i>Help
                            </button>
                        </div>
                    </div>
                </form>

                <table class="table table-sm table-striped table-hover align-middle">
                    <caption>
                        <div class="container-fluid">
                            <div class="row justify-content-center align-self-center">
                                <div class="col align-self-center">
                                    {{ this.total$ | async }} Total
                                </div>
                                <div class="col text-end">
                                    <button title="Add combination" (click)="onAdd()"
                                            class="btn btn-sm btn-outline-primary">
                                        <i class="bi bi-plus-circle me-1"></i> Add
                                    </button>
                                </div>
                            </div>
                        </div>
                    </caption>

                    <thead>
                    <tr>
                        <th scope="col" sortable="customerName" (sort)="this.onSort($event)">Customer</th>
                        <th scope="col" sortable="isaReceiverId" (sort)="this.onSort($event)">ISA Receiver ID</th>
                        <th scope="col" sortable="senderName" (sort)="this.onSort($event)">Trading Partner</th>
                        <th scope="col" sortable="isaSenderId" (sort)="this.onSort($event)">ISA Sender ID</th>
                        <th scope="col" sortable="updatedAt" (sort)="this.onSort($event)">Updated</th>
                        <th scope="col" class="text-center" sortable="isActive" (sort)="this.onSort($event)">Active</th>
                    </tr>
                    </thead>

                    <tbody class="table-group-divider">
                        @for (element of this.combinations$ | async; track element.id) {
                            <tr>
                                <td class="align-middle">{{ element.customerName ?? '—' }}</td>
                                <td class="align-middle text-nowrap">{{ element.isaReceiverId }}</td>
                                <td class="align-middle">{{ element.senderName ?? '—' }}</td>
                                <td class="align-middle text-nowrap">{{ element.isaSenderId }}</td>
                                <td class="align-middle text-nowrap">{{ element.updatedAt.substring(0, 10) }}</td>
                                <td class="align-middle">
                                    <div class="form-check form-switch  d-flex justify-content-center">
                                        <input #activeSwitch class="form-check-input" type="checkbox" role="switch"
                                               [id]="'active-' + element.id"
                                               [checked]="element.isActive"
                                               [attr.aria-label]="'Active: ' + element.isaSenderId + ' to ' + element.isaReceiverId"
                                               (change)="onToggleActive(element, activeSwitch)">
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>

                @if (((this.total$ | async) ?? 0) > 0) {
                    <app-table-pager [total]="(this.total$ | async)!" [(page)]="this.service.page" [(pageSize)]="this.service.pageSize" />
                }

                @if (((this.total$ | async) ?? 0) == 0 && !(this.globalService.waitOverlayIsVisible$ | async)) {
                    <div class="card text-center bg-warning-subtle border border-warning rounded p-3 m-5">
                        <div class="card-body">
                            <i class="bi bi-exclamation-triangle-fill me-2"></i>No sender/receiver combinations found.
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>

    <ng-template #addModal>
        <div class="modal-header">
            <h5 class="modal-title">
                <i class="bi bi-shield-check me-2"></i>Add Sender/Receiver Combination
            </h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="this.closeModal()"></button>
        </div>
        <form [formGroup]="form" (ngSubmit)="onSave()" autocomplete="off">
            <div class="modal-body">
                <div class="form-floating mb-3">
                    <select id="isaReceiverId" class="form-select" formControlName="isaReceiverId"
                            [class.is-invalid]="isControlInvalid(form.controls.isaReceiverId)">
                        <option value="" disabled>Select a customer</option>
                        @for (customer of customers; track customer.id) {
                            <option [value]="customer.code">{{ customer.name }} ({{ customer.code }})</option>
                        }
                    </select>
                    <label for="isaReceiverId" class="form-label">Customer (ISA Receiver)</label>
                    <div class="invalid-feedback">Required</div>
                </div>
                <div class="form-floating mb-3">
                    <select id="isaSenderId" class="form-select" formControlName="isaSenderId"
                            [class.is-invalid]="isControlInvalid(form.controls.isaSenderId)">
                        <option value="" disabled>Select a trading partner</option>
                        @for (partner of partners; track partner.code) {
                            <option [value]="partner.code">{{ partner.name }} ({{ partner.code }})</option>
                        }
                    </select>
                    <label for="isaSenderId" class="form-label">Trading Partner (ISA Sender)</label>
                    <div class="invalid-feedback">Required</div>
                </div>
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="isActiveSwitch" formControlName="isActive">
                    <label class="form-check-label" for="isActiveSwitch">Active</label>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary" [disabled]="savingData">
                    @if (!savingData) {
                        <span>Save</span>
                    }
                    @else {
                        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    }
                </button>
                <button type="button" class="btn btn-secondary" (click)="this.closeModal()" [disabled]="savingData">Cancel</button>
            </div>
        </form>
    </ng-template>

    <ng-template #helpModal let-modal>
        <div class="modal-header">
            <h4 class="modal-title">
                <i class="bi bi-question-circle me-2"></i>EDI Sender/Receivers > Help
            </h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>
        <div class="modal-body">
            <p>
                EDI 852/867 files are processed only when their sender (trading partner) and receiver (customer)
                pair is listed here and <strong>active</strong>. Files from other pairs are held back until the pair
                is active.
            </p>
            <ul class="mb-0">
                <li><strong>Inactive pair:</strong> new files from this sender for this customer are not processed.
                    Data that is already loaded stays.</li>
                <li><strong>Pair not listed:</strong> files are held back the same way. Add the pair before a new
                    trading partner starts sending data for a customer.</li>
                <li><strong>Activating a pair:</strong> any held-back files are processed in the next run.</li>
                <li><strong>Reprocess requests</strong> for files from an inactive pair wait until the pair is
                    active.</li>
            </ul>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
        </div>
    </ng-template>

    <app-modal-confirm #confirmationModal></app-modal-confirm>
</div>
